// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "545") return "js/vendors-3648adb29ac55d20.js";
if (chunkId === "691") return "js/vendor-super-form-c5ff111b53478f15.js";
  // return url for filenames based on template
  return "js/" + {"94": "vendor-vega","960": "vendor-interrai-english",}[chunkId] + "-" + {"94": "200bff5849b2c427","960": "57db53a444f4df76",}[chunkId] + ".chunk.js"
}